module.exports = __webpack_public_path__ + "fonts/AvenirLight.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/AvenirLight.ttf
// module id = 324
// module chunks = 12